import store from 'store';

export const WG_TOKEN_STORE_KEY = '__WLD_WG_PWD__';

export const setAccessAuthToken = (recordId, token) => {
  const localStore = store.get(WG_TOKEN_STORE_KEY) || {};

  store.set(WG_TOKEN_STORE_KEY, {
    ...localStore,
    [recordId]: token,
  });
};

export const getAccessAuthToken = recordId => {
  const localStore = store.get(WG_TOKEN_STORE_KEY) || {};

  return localStore[recordId];
};
